import { render } from "./RequestNewAccessToken.vue?vue&type=template&id=2502339e"
import script from "./RequestNewAccessToken.vue?vue&type=script&lang=js"
export * from "./RequestNewAccessToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__